<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">设置高度</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-form :model="addForm" :rules="rules" ref="addForm">
          <el-row>
            <el-col :span="12" class="item">
              <el-form-item label="高度(200～300厘米)" required prop="height">
                <el-input v-model="addForm.height" placeholder="输入高度，默认：240"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>

      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('addForm')">设置</el-button>
      </div>
    </div>

  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";


export default {
  name: 'Add',
  data() {
    return {
      loading: false,

      addForm:{
        timeStr:timeStr,
        sign:'',

        deviceQLFallCode:'',
        height:'240',

      },

      rules:{
        height:[
          { required: true, message: '请输入高度', trigger: 'blur' },
        ],
        alarmTime:[
          { required: true, message: '请输入报警时间', trigger: 'blur' }
        ],

      }


    }
  },
  components: {

  },
  methods: {
    init(row){
      this.$refs.addForm.resetFields();

      this.addForm.deviceQLFallCode = row.deviceQLFallCode;
      this.addForm.height= row.height;

    },

    closeSelf() {
      this.$emit("closeMe");
    },


    confirm(addForm){
      this.$refs[addForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          console.log('error submit!!');
          return false;
        }
      })

    },

    addSubmit(){

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);


      this.$axios({
        method: 'post',
        url: this.$deviceUrl+"DeviceQLFall/SetHeightForCTD",
        data: this.addForm
      }).then((response) => {
        this.loading = false;
        if (response.data.error == 0) {
          this.$emit("closeMe");
          this.$emit("getList");

          this.$message.success("设置成功")

        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }

      })
    },


  }
}

</script>


<style lang="scss" scoped>

</style>
